module.exports = __webpack_public_path__ + "img/selected2-min.07a0d90e.png";